import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Section from '../../components/Section'
import PhotoUpload from '../../components/PhotoUpload'
import StudentList from '@/components/StudentList'
import Button from '@/components/Button'

export default function AccountPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      <title>My Account - Book Blast by Books Are Fun</title>
      <div className='w-full flex flex-col'>
        <div className='bg-cta text-center px-4 md:px-8 '>
          <h1 className='text-white text-3xl font-serif text-center font-bold'>{t('content.account_page.title')}</h1>
          <div className='text-white pt-2'>{t('content.account_page.subtitle')}</div>
        </div>

        <Section wrapperStyle='min-h-58 mt-8'>
          <PhotoUpload />
        </Section>

        <Section wrapperStyle='mt-16 mb-4'>
          <StudentList />
          <div className='flex justify-center mx-auto w-full sm:w-2/3 md:w-1/2'>
            <Button
              label={t('content.components.current_students.add_student_button_title')}
              variant='cta'
              fullwidth
              onClick={() => navigate('../add-student')}
            />
          </div>
        </Section>
      </div>
    </>
  )
}
